// utils/geoLocalization.ts

type TSupportedLanguage = 'en' | 'es';

// Используем Set для быстрого поиска (O(1)). 
// Здесь собраны ISO-коды Испании и испаноязычных стран Латинской Америки.
const spanishCountries = new Set([
  'ES', // Испания
  'MX', // Мексика
  'AR', // Аргентина
  'CO', // Колумбия
  'PE', // Перу
  'VE', // Венесуэла
  'CL', // Чили
  'EC', // Эквадор
  'GT', // Гватемала
  'CU', // Куба
  'BO', // Боливия
  'DO', // Доминиканская Республика
  'HN', // Гондурас
  'PY', // Парагвай
  'SV', // Сальвадор
  'NI', // Никарагуа
  'CR', // Коста-Рика
  'PA', // Панама
  'UY', // Уругвай
  'PR',  // Пуэрто-Рико
  // 'AM'  // Пуэрто-Рико
]);

/**
 * Определяет язык на основе кода страны.
 * Если страна испаноязычная — возвращает 'es', для всех остальных — 'en'.
 */
export const getLanguageFromCountry = (
  countryCode: string | null | undefined
): TSupportedLanguage => {
 
  if (!countryCode) return 'en'; // Защита от null/undefined

  const normalizedCode = countryCode.trim().toUpperCase();
  
  // Если код есть в нашем списке испаноязычных стран, возвращаем 'es'
  if (spanishCountries.has(normalizedCode)) {
    return 'es';
  }

  // В противном случае (AM, US, GB, RU и вообще любые другие)
  return 'en';
};